import { createUseQuery } from 'api/common/createUseQuery'
import { fetchFileById, PersistentPlatformFile } from 'api/fetchers/fetchFileById'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useFileById = createUseQuery({
  queryKey: ApiQueryKeys.MT_FILE_BY_ID,
  fetcher: fetchFileById,
  selector: res => (res?.data as PersistentPlatformFile) ?? ({} as PersistentPlatformFile),
})
